import dayjs from 'dayjs';
import moment from 'moment';
import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';
import getContractStatus from '../Purchasers/getContractStatus.api';
import _ from 'lodash';

const firebaseRef = firebase.database();
const filterByTodayArr = [
	'6am',
	'7am',
	'8am',
	'9am',
	'10am',
	'11am',
	'12pm',
	'1pm',
	'2pm',
	'3pm',
	'4pm',
	'5pm',
	'6pm',
	'7pm',
	'8pm',
	'9pm',
	'10pm',
	'11pm',
	'12am',
];
const filterByMonthArr = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec',
];
export async function getTotalSalesForCurrentAgent(
	salesAgentId,
	filterByDate,
	callback
) {
	await firebaseRef
		.ref('/kavtek_purchasers/' + PROJECT_CODE.projectCode)
		.orderByKey()
		.equalTo(salesAgentId)
		.on('value', async (snapshot) => {
			// 1-1. Get deals key by agent id
			try {
				let purchasersParent = snapshot?.val();

				let purchasersKeys = [];
				let purchaserObj =
					purchasersParent &&
					purchasersParent[Object?.keys(purchasersParent)];
				purchasersKeys = purchaserObj && Object?.keys(purchaserObj);

				if (purchasersKeys) {
					await firebaseRef
						.ref('/kavtek_agreements/' + PROJECT_CODE.projectCode)
						.on('value', (snapshot) => {
							// 1-2. Get deals object from DB
							let agreementsParant = snapshot.val();
							if (agreementsParant) {
								let agreementsKeys =
									Object.keys(agreementsParant);

								let filteredArr = purchasersKeys.filter(
									(value) => agreementsKeys.includes(value)
								);
								let totalSalesObj = getTotalSalesObj(
									agreementsParant,
									filteredArr,
									filterByDate
								);
								callback(totalSalesObj);
							} else {
								callback({
									totalSales: 0,
								});
							}
						});
				} else {
					callback({
						totalSales: 0,
					});
				}
			} catch (err) {
				console.log('⚠️ Error ⚠️: ' + err.message);
				callback({
					totalSales: 0,
				});
			}
		});
}

export async function getTotalSalesForAllAgents(filterByDate, callback) {
	await firebaseRef
		.ref('/kavtek_purchasers/' + PROJECT_CODE.projectCode)
		.on('value', async (snapshot) => {
			try {
				let purchasersParent = snapshot?.val(); // (Firebase) data from DB
				if (purchasersParent) {
					await firebaseRef
						.ref('/kavtek_agreements/' + PROJECT_CODE.projectCode)
						.on('value', (snapshot) => {
							// 1. Get all lead id from kavtek_purchaser
							let purchasersArr = [];
							for (let agentKey in purchasersParent) {
								let purchaserChild = purchasersParent[agentKey];
								let purchaserChildKeys =
									Object.keys(purchaserChild);

								purchasersArr =
									purchasersArr.concat(purchaserChildKeys); // 🚩 Check are there dupliceate lead in diffrent sales agent
							}

							// 2. Get all lead id from kavtek_agreement
							let agreementsParent = snapshot?.val();

							// 3. Get intersertion between 1 and 2
							if (agreementsParent) {
								let agreementParentKeys =
									Object.keys(agreementsParent);
								let filteredArr = purchasersArr.filter(
									(value) =>
										agreementParentKeys.includes(value)
								);

								let totalSalesObj = getTotalSalesObj(
									agreementsParent,
									filteredArr,
									filterByDate
								);
								callback(totalSalesObj);
							} else {
								callback({
									totalSales: 0,
								});
							}
						});
				} else {
					callback({
						totalSales: 0,
					});
				}
			} catch (err) {
				// When dealsParent is either undefined or empty object
				console.log('⚠️ Error ⚠️: ' + err.message);
				throw err.message;
			}
		});
}
function getTotalSalesObj(deals, pointer, filterByDate) {
	try {
		let dealsParent = deals;
		let dealsPointer = pointer;

		// 4-1. Has documentInformation?
		// 4-2. documentStatus === sent ?
		// 4-3. Is it cancelled ?
		let sentDocsObjs = [];

		for (let i = 0; i < dealsPointer.length; i++) {
			let key = dealsPointer[i];
			if (
				dealsParent[key]?.documentInformation?.documentStatus ===
					'sent' ||
				dealsParent[key]?.documentInformation?.documentStatus ===
					'cancelled'
			) {
				sentDocsObjs.push(dealsParent[key]);
			}
			// if (
			// 	dealsParent[key]?.documentInformation?.documentStatus === 'sent'
			// ) {
			// 	getContractStatus({ leadId: key }, (returned) => {
			// 		returned.name !== 'Cancelled' &&
			// 			sentDocsObjs.push(dealsParent[key]);
			// 	});
			// }
		}

		let filterByDateArr;

		filterByDateArr = sentDocsObjs.filter((sentDocobj) => {
			if (filterByDate === 'All') {
				return true;
			} else {
				let signatureRequestsObj =
					sentDocobj['documentInformation']['signatureRequests'];
				let signatureRequestsObjKeys =
					Object.keys(signatureRequestsObj);
				let timestamp =
					signatureRequestsObj[signatureRequestsObjKeys[0]][
						'timestamp'
					];
				if (filterByDate === 'Month') {
					// 2020-11-08 10:00 AM ~ 2021-11-08 10:00 AM
					return moment(timestamp).isBetween(
						//moment().subtract(12, 'months'),.startOf('year')
						moment().startOf('year'),
						moment()
					);
				} else if (filterByDate === 'Week') {
					// 2021-11-02 10:00 AM ~ 2021-11-08 10:00 AM
					return moment(timestamp).isBetween(
						moment().subtract(7, 'days'),
						moment()
					);
				} else if (filterByDate === 'Today') {
					// 2021-11-08 6:00 AM ~ 2021-11-08 10:00 AM
					return moment(timestamp).isBetween(
						moment().startOf('day'),
						moment()
					);
				} else {
					return true;
				}
			}
		});

		// // 4. Get sorted uniqueKeys by timestamp
		let sortedArr;
		sortedArr = filterByDateArr.sort(compare);
		// // 5. Set time labeling by filters when Weeks or Today
		// // Need to get time labeling based on current day for filter by weeks and by today
		// // For filter by month, need to get timestamp value, so we can get from step 6
		// // (ex) filter by weeks: 11-08, 11-07, 11-06, 11-05, 11-04, 11-03, 11-02
		// // (ex) filter by todday: 6am to 12 am
		let timeStampArray = [];
		if (filterByDate === 'Week') {
			let filterByWeek = [];
			for (let i = 6; i >= 0; i--) {
				let d = new Date();
				d.setDate(d.getDate() - i);
				filterByWeek.push(dayjs(d).format('MMM D'));
			}
			timeStampArray = filterByWeek;
		} else if (filterByDate === 'Today') {
			timeStampArray = filterByTodayArr;
		}

		// // 6. Get total sales array
		// // Get total sales label when filter by month and filter by all
		let totalNetSales = 0;
		let totalSalesArray = [];
		let thisYear = moment().startOf('year');
		let hasLastyear = false;
		sortedArr.forEach((docSentObj) => {
			let docStatus = docSentObj?.documentInformation?.contractStatus;
			let signatureRequestsObj =
				docSentObj?.documentInformation?.signatureRequests;
			let signatureRequestsObjKeys =
				signatureRequestsObj && Object?.keys(signatureRequestsObj);

			let timestamp =
				signatureRequestsObj?.[signatureRequestsObjKeys?.[0]]?.[
					'timestamp'
				];
			let lotPrice =
				docSentObj?.['productAvailability']?.['lotPrice'] || 0;
			let elevation =
				docSentObj?.['productAvailability']?.['elevation']?.['price'] ||
				0;
			let options = docSentObj['totalOptions'] || 0;

			let totalSale =
				parseFloat(lotPrice) +
				parseFloat(elevation) +
				parseFloat(options);
			if (docStatus === 'Firm') {
				totalNetSales = totalNetSales + totalSale || 0;
			}

			if (moment(timestamp).isSameOrBefore(thisYear)) hasLastyear = true;
			if (filterByDate === 'Month') {
				// Create timeStampArray between the month(has first deal) and current month
				// Create totalSalesArray (no duplucate month)
				if (timeStampArray.length === 0) {
					let startMon = dayjs(timestamp).format('M');
					let currentMon = dayjs(new Date()).format('M');
					let timeArr = Array.from(
						{ length: currentMon - startMon + 1 },
						(_, i) => filterByMonthArr[i + parseInt(startMon) - 1]
					);
					timeStampArray = timeArr;
					totalSalesArray[0] = totalSale;
				} else {
					timeStampArray.map((el, i) => {
						if (el === dayjs(timestamp).format('MMM')) {
							if (totalSalesArray[i]) {
								// Case 1: Deal O, but there is a deal on the same month
								totalSalesArray[i] += Number(totalSale);
							} else {
								// Case 2: Deal O, but no deal yet on the same month
								totalSalesArray[i] = Number(totalSale);
							}
						} else if (totalSalesArray[i] === undefined) {
							// Case 3: No deals
							totalSalesArray[i] = 0;
						}
					});
				}
			} else if (filterByDate === 'Week') {
				// Create totalSalesArray (no duplucate week)
				let time = dayjs(timestamp).format('MMM D');
				timeStampArray.map((el, i) => {
					if (el === time) {
						if (totalSalesArray[i]) {
							// Case 1: Deal O, but there is a deal on the same week
							totalSalesArray[i] += Number(totalSale);
						} else {
							// Case 2: Deal O, but no deal yet on the same week
							totalSalesArray[i] = Number(totalSale);
						}
					} else if (totalSalesArray[i] === undefined) {
						// Case 3: No deals
						totalSalesArray[i] = 0;
					}
				});
			} else if (filterByDate === 'Today') {
				// Create totalSalesArray (no duplucate time)
				let startTime = 6; // Chart starts 6 am
				let timeDeal =
					dayjs(timestamp).format('H') < startTime
						? startTime
						: dayjs(timestamp).format('H');
				let timeNow = dayjs(new Date()).format('H');

				// Get time label array from 6 am to current time
				let timeArr = Array.from(
					{ length: timeNow - startTime + 1 },
					(_, i) => i + startTime
				);

				timeArr.map((el) => {
					if (parseInt(el) === parseInt(timeDeal)) {
						if (totalSalesArray[el - startTime]) {
							// Case 1: Deal O, but there is a deal on the same time
							totalSalesArray[el - startTime] +=
								Number(totalSale);
						} else {
							// Case 2: Deal O, but no deal yet on the same time
							totalSalesArray[el - startTime] = Number(totalSale);
						}
					} else if (totalSalesArray[el - startTime] === undefined) {
						// Case 3: No deals
						totalSalesArray[el - startTime] = 0;
					}
				});
			} else {
				hasLastyear
					? timeStampArray.push(dayjs(timestamp).format('YY-MMM-D'))
					: timeStampArray.push(dayjs(timestamp).format('MM-DD'));
				totalSalesArray.push(parseInt(totalSale));
			}
		});
		// 7. Get sum of totalSales
		let totalSales;
		totalSales = totalSalesArray.reduce(
			(a, b) => parseInt(a) + parseInt(b),
			0
		);

		// 8. Create timeStampObject
		let timeStampObject = {};
		timeStampArray.forEach((el, i) => {
			if (timeStampObject[el]) {
				timeStampObject[el] += totalSalesArray[i];
			} else {
				timeStampObject[el] = totalSalesArray[i];
			}
		});

		// 	// // 9. Return totalSalesObj
		let totalSalesObj;
		if (totalSalesArray.length === 0) {
			// When there is no qualified data
			totalSalesObj = {
				totalSales: totalSales,
			};
		} else {
			// When there is qualified data
			totalSalesObj = {
				totalSales: totalSales,
				timeArr: Object.keys(timeStampObject),
				salesArr: Object.values(timeStampObject),
				totalNetSales: totalNetSales,
			};
		}
		console.log('totalSalesObj:', totalSalesObj);
		return totalSalesObj;
	} catch (err) {
		throw err.message;
	}
}

function compare(keyA, keyB) {
	let objA = keyA['documentInformation']['signatureRequests'];
	let objB = keyB['documentInformation']['signatureRequests'];

	let objAKey = Object.keys(objA);
	let objBKey = Object.keys(objB);

	let timestampA = objA[objAKey[0]]['timestamp'];
	let timestampB = objB[objBKey[0]]['timestamp'];

	if (timestampA > timestampB) return 1;
	if (timestampA < timestampB) return -1;
	return 0;
}
